import { MetricsWidgetCta } from '@linearb/linui-common';
import { resolvePremiumMetricTitle } from './CustomReport.new.helpers';
import { navigateBookDemoClick } from 'common/utils/utils';
import { useMemo } from 'react';
import { PREMIUM_METRICS_CTA } from './CustomReport.new.consts';

/**
 * @typedef {import('./CustomReport.new.helpers').Graph} Graph
 */

/**
 * @param {object} props
 * @param {Graph} props.graph
 * @param {boolean} props.isTeamLicense
 * @returns {JSX.Element}
 */
export const PremiumMetricsCta = ({ graph, isTeamLicense }) => {
  const widgetTitle = useMemo(() => resolvePremiumMetricTitle(graph), [graph]);
  const { TITLE, SUB_TITLE, BUTTON_TEXT } = isTeamLicense
    ? PREMIUM_METRICS_CTA.FREE
    : PREMIUM_METRICS_CTA.PAID;

  return (
    <MetricsWidgetCta
      widgetTitle={widgetTitle}
      title={TITLE}
      subtitle={SUB_TITLE}
      buttonText={BUTTON_TEXT}
      onButtonClick={navigateBookDemoClick}
      sx={{ margin: '1rem', height: '82.5%' }}
    />
  );
};
